import { delay, put, takeEvery, call, select } from 'redux-saga/effects';
import { RequestCodeListAction, RequestScriptListAction } from 'redux/actions/type';
import { REQUEST_CODE_LIST, REQUEST_SCRIPT_LIST } from 'redux/actions/types';
import { getAPI } from 'commons/framework/KeyFlowAPIRequest';
import KeyFlowResponse from 'commons/framework/KeyFlowResponse';
import { API } from 'commons/constants/KeyFlowAPI';
import {
  changeWkblVideoSeason,
  requestCodeListFailure,
  requestCodeListSuccess,
  requestScriptListFailure,
  requestScriptListSuccess,
  throwError,
} from 'redux/actions/actions';
import ScriptVO from 'commons/vo/Script';
import { PaginationType } from 'commons/framework/type';
import CodeVO from 'commons/vo/CodeVO';
import { CodeValue, CODE_NAME } from 'commons/constants/KeyFlowConstants';
import { AxiosResponse } from 'axios';

function* requestCodeListSaga(action: RequestCodeListAction) {
  try {
    const response: AxiosResponse = yield call(getAPI, API.CODE);
    const keyFlowResponse = new KeyFlowResponse(response.data);
    const resultList: CodeVO[] = keyFlowResponse.getResult(CodeVO) as CodeVO[];

    let kfScriptTypeList: CodeVO[] = [];
    let kfScriptRefRangeList: CodeVO[] = [];
    let videoTypeList: CodeVO[] = [];
    let wkblSeasonList: CodeVO[] = [];
    let wkblGameTypeList: CodeVO[] = [];

    const parentsList = resultList.filter(code => !code.pid);

    parentsList.forEach(pCode => {
      const codevalue = pCode.codevalue;
      const id = pCode.id;
      switch (codevalue) {
        case CodeValue.KF_SCRIPT_TYPE: {
          kfScriptTypeList = resultList.filter(cCode => cCode.pid === id);
          break;
        }
        case CodeValue.KF_SCRIPT_REF_RANGE: {
          kfScriptRefRangeList = resultList.filter(cCode => cCode.pid === id);
          break;
        }

        case CodeValue.VIDEO_TYPE: {
          videoTypeList = resultList.filter(cCode => cCode.pid === id);
          break;
        }
        case CodeValue.WKBL_SEASON: {
          wkblSeasonList = resultList
            .filter(cCode => cCode.pid === id)
            .sort((a, b) => {
              return a.codevalue > b.codevalue ? -1 : a.codevalue < b.codevalue ? 1 : 0;
            });
          break;
        }
        case CodeValue.WKBL_GAME_TYPE: {
          wkblGameTypeList = resultList
            .filter(cCode => cCode.pid === id)
            .sort((a, b) => {
              return a.seq - b.seq;
            });
          break;
        }
      }
    });
    yield put(
      requestCodeListSuccess({
        kfScriptTypeList,
        kfScriptRefRangeList,
        videoTypeList,
        wkblSeasonList,
        wkblGameTypeList,
      }),
    );
    const seasonId = String(wkblSeasonList[0].id);
    yield put(changeWkblVideoSeason({ season: seasonId }));
  } catch (error: any | Error) {
    yield put(throwError({ error }));
    yield put(requestCodeListFailure());
  }
}

export function* watchCodeSaga() {
  yield takeEvery(REQUEST_CODE_LIST, requestCodeListSaga);
}
